import { LinkButton } from '@sleepstation/components'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { maxWidth, mq } from '@sleepstation/style-api-helpers'
import { defaultAltTheme } from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'
import AudioPlayer from '../../../../../shared/AudioPlayer'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const AUDIO_DOWNLOAD_BUTTON_LABEL = `Download audio`

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
  align: LAYOUT_ALIGN.STRETCH,
})``

const Footer = styled(VLayout).attrs({ align: LAYOUT_ALIGN.CENTER })`
  > * {
    width: 100%;

    ${mq(`smallUp`)} {
      ${maxWidth(12)}
    }
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const AudioContent = ({ url }) => (
  <Layout>
    <AudioPlayer url={url} />

    <Footer>
      <ThemeProvider theme={defaultAltTheme}>
        <LinkButton
          href={url}
          icon="download"
          kind="secondary"
          iconIsLast
          download
        >
          {AUDIO_DOWNLOAD_BUTTON_LABEL}
        </LinkButton>
      </ThemeProvider>
    </Footer>
  </Layout>
)

AudioContent.propTypes = {
  url: PropTypes.string.isRequired,
}

export default AudioContent
